import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import KYCHeader from '@/components/KYCHeader';

export default function KYCLayout() {
  return (
    <div className="min-h-screen bg-[#FFFFFF] dark:bg-[#000000]">
      {/* KYC Header */}
      <KYCHeader />

      {/* Page Content */}
      <main className="min-h-screen">
        <Suspense
          fallback={
            <div>
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </main>
    </div>
  );
}
